import { render } from "./DailyReview.vue?vue&type=template&id=0f03a898&scoped=true"
import script from "./DailyReview.vue?vue&type=script&lang=js"
export * from "./DailyReview.vue?vue&type=script&lang=js"

import "./DailyReview.vue?vue&type=style&index=0&id=0f03a898&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f03a898"]])

export default __exports__